<template>
    <section>
        <table class="table fading table-borderless">
            <thead>
            <tr>
                <td></td>
                <td>Account</td>
                <td v-if="type === SENTIMENT" class="text-right">Comments</td>
                <td v-if="type === SENTIMENT" class="text-right">Avg. sentiment</td>
                <td v-if="type === MENTIONED">Mentioned</td>
                <td v-if="type === BIGGEST" class="text-right">Commented</td>
                <td v-if="type === BIGGEST" class="text-right">Followers</td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="account in accounts" :key="account.user_name">
                <td>
                    <img :src="account.profile_picture || 'https://abs.twimg.com/sticky/default_profile_images/default_profile_normal.png'" class="img-circle profile-picture">
                </td>
                <td>
                    <a :href="'https://instagram.com/' + account.user_name + '/'" target="_blank">{{account.user_name}}</a>
                </td>
                <td v-if="type === SENTIMENT" class="text-right">
                    {{account.comments}}
                </td>
                <td v-if="type === SENTIMENT" :class="{'text-success': account.sentiment > 0, 'text-danger': account.sentiment < 0}" class="text-right">
                    <strong>{{account.sentiment | round(2) }}</strong>
                </td>
                <td v-if="type === MENTIONED" class="text-right">
                    {{account.count}}x
                </td>
                <td v-if="type === BIGGEST" class="text-right">
                    {{account.comments}}x
                </td>
                <td v-if="type === BIGGEST" class="text-right">
                    <strong>{{account.followers}}</strong>
                </td>

            </tr>
            <tr v-for="i in remain" :key="i" class="dummy-row">
                <td></td>
                <td></td>
                <td v-if="type === SENTIMENT"></td>
                <td v-if="type === SENTIMENT"></td>
                <td v-if="type === MENTIONED"></td>
                <td v-if="type === BIGGEST"></td>
                <td v-if="type === BIGGEST"></td>
            </tr>
            </tbody>
        </table>
    </section>
</template>

<script>
    const SENTIMENT = 'sentiment'
    const BIGGEST = 'biggest'
    const MENTIONED = 'mentioned'

    export default {
        name: 'Accounts',
        props: ['accounts', 'type'],
        data () {
            return {
                SENTIMENT,
                BIGGEST,
                MENTIONED
            }
        },
        computed: {
            remain () {
                return 5 - this.accounts.length
            }
        }
    }
</script>

<style scoped>
    .dummy-row {
        height: 62px;
    }
    .profile-picture {
        width: 32px;
        border-radius: 50%;
    }
    table.table td {
        padding: 6px;
        vertical-align: middle;
    }
</style>
